import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { translate } from "../../i18n/customI18nProvider";
export function ConfirmTableNumberModal({ tableNumber, open, onClose, onConfirm }) {
    const [inputTableNumber, setInputTableNumber] = React.useState(tableNumber || "");

    React.useEffect(() => {
        setInputTableNumber(tableNumber || "");
    }, [tableNumber, open]);

    const handleConfirm = () => {
        onConfirm(inputTableNumber.trim());
        onClose();
    }

    return (
        <Dialog fullWidth={true} open={open} onClose={onClose} PaperProps={{ sx: { position: 'absolute', top: 16, m: 0 } }}>
            <DialogTitle>{translate('custom.table_number')}</DialogTitle>            
            <DialogContent>
                <Typography variant="body1" gutterBottom>
                    {translate('custom.confirm_table_number')}
                </Typography>
                <TextField
                    autoFocus
                    margin="dense"
                    label={translate('custom.table_number')}
                    type="text"
                    fullWidth
                    value={inputTableNumber}
                    disabled
                    onChange={(e) => setInputTableNumber(e.target.value)}
                />
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    {translate('custom.scan_qr_code_again')}
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>{translate('custom.cancel')}</Button>
                <Button onClick={handleConfirm} disabled={inputTableNumber.trim() === ""} variant="contained">{translate('custom.confirm')}</Button>
            </DialogActions>
        </Dialog>
    );
}